import { blockedwordConstants } from '../constants';
import { blockedwordService } from '../services';
import { showToast } from '../services/toast';

export const blockedwordActions = {
    fetchBlockedWords,
    createBlockedWord,
    updateBlockedWord,
    deleteBlockedWord
};

function fetchBlockedWords() {
    return dispatch => {
        dispatch(request());

        blockedwordService.fetchBlockedWords()
            .then(
                response => {
                    dispatch(success(response.data));
                    return response;
                },
                error => {
                    dispatch(failure(error));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                }
            );
    };

    function request() { return { type: blockedwordConstants.FETCH_BLOCKEDWORDS_REQUEST } }
    function success(blockedwords) { return { type: blockedwordConstants.FETCH_BLOCKEDWORDS_SUCCESS, blockedwords } }
    function failure(error) { return { type: blockedwordConstants.FETCH_BLOCKEDWORDS_FAILURE, error } }
}

function createBlockedWord(blockedwordsDetails) {
    return dispatch => {
        dispatch(request());

        return blockedwordService.createBlockedWord(blockedwordsDetails)
            .then(
                response => {
                    dispatch(success(response.data));
                    showToast(response.responseMessage, 'success');
                },
                error => {
                    dispatch(failure(error.toString()));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                    return Promise.reject(error);
                }
            );
    };

    function request() { return { type: blockedwordConstants.CREATE_BLOCKEDWORD_REQUEST } }
    function success(blockedwords) { return { type: blockedwordConstants.CREATE_BLOCKEDWORD_SUCCESS, blockedwords } }
    function failure(error) { return { type: blockedwordConstants.CREATE_BLOCKEDWORD_FAILURE, error } }
}

function updateBlockedWord(blockedwordsDetails) {

    return dispatch => {
        dispatch(request());

        return blockedwordService.updateBlockedWord(blockedwordsDetails)
            .then(
                response => {
                    dispatch(success(response.data));
                    showToast(response.responseMessage, 'success');
                },
                error => {
                    dispatch(failure(error));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                }
            );
    };

    function request() { return { type: blockedwordConstants.UPDATE_BLOCKEDWORD_REQUEST } }
    function success(blockedwords) { return { type: blockedwordConstants.UPDATE_BLOCKEDWORD_SUCCESS, blockedwords } }
    function failure(error) { return { type: blockedwordConstants.UPDATE_BLOCKEDWORD_FAILURE, error } }

}

function deleteBlockedWord(blockedwordId) {

    return dispatch => {
        dispatch(request());
        
        return blockedwordService.deleteBlockedWord(blockedwordId)
            .then(
                (response) => {
                    dispatch(success(blockedwordId));
                    showToast(response.responseMessage, 'success');
                },
                error => {
                    dispatch(failure(error.toString()));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                }
            );
    };

    function request() { return { type: blockedwordConstants.DELETE_BLOCKEDWORD_REQUEST } }
    function success(id) { return { type: blockedwordConstants.DELETE_BLOCKEDWORD_SUCCESS, payload: id } }
    function failure(error) { return { type: blockedwordConstants.DELETE_BLOCKEDWORD_FAILURE, error } }
}